import { Api_urls } from "../services/config";



/**
 * This file contains endpoint constants.
 */
export const Adminmoduleapi = {

    serviceEndpoint: Api_urls.apiUrl,

    postadmins:"v1/user/register",

    getdriverlist:"v2/drivers",
    postdriver:"v1/driver",

    getownerlist:"v2/owners",
    postowner:"v1/owner",

    getjobslist:"v1/job-titles",
    postupdatejoblist:"v1/job-titles",

    loginTokenApi:"v1/user/login",

    getjobtypelist:"v1/job-types",
    postupdatejobtypelist:"v1/job-types",
    deletejobtypes:"v1/job-type",

    getvehicletypelist:"v1/vehicle-types",
    postupdatevehiclelist:"v1/vehicle-types",
    deletevehiclelist:"v1/vehicle-types",

    getlicencetypelist:"v1/licence-types",
    postupdatelicencelist:"v1/licence-types",
    deletelicencelist:"v1/licence-types",

    getcountrylist:"v1/settings/country",
    postupdatecountrylist:"v1/country",
    deletecountrylist:"v1/country",

    getrealtimelist:"v1/users/count"
} //end of 'api' block


export const usermoduleapi = {

    serviceEndpoint: Api_urls.apiUrl,

    getjobslistbycountry:"v2/jobs",

    getjobslistbyserach:"v2/search/jobs",

    setNotification:"v1/app/notifications",

    getjobslistbyfilter:"v2/filter/jobs",

    getuserLocation:"v1/user/location",

    getuserbydriverinfo:"v1/user",

    loginTokenApi:"v1/user/login",

    loginouthApi : "v1/user/oAuth/signup",

    postownerjobbycountry:"v1/owner/job",

    deletenotificationsbyid:"v1/app/notifications/delete",

    deletejobbyid:"v1/delete/jobs",

    profilelockunlock:"v1/user/lock-unlock",

    profileDelete:"v1/user/delete",

    restpwdbymail:"v1/user/forgot-password",

    resetpwdverifymail:"v1/user/reset-password",

    changepwd:"v1/user/change-password",

    getJobtypes:"v1/job-types",

    getJobbycites:"v1/job-cities",

    profileUpdate:"v1/user",

    profilerefresh:"v1/user/refresh",

    drivinglicenceupload:"v1/user/profile/licence/upload",

    jobcreatebyowner:"v1/owner/job",

    jobdeletebyowner:"v1/jobs",

    jobsrefresh:"v1/jobs/refresh",

    getownerjobs:"v1/owner/jobs",

    editownerjob:"v1/job",

    jobdetailsbyid:"v1/job",

    refershjobbyid:"v1/jobs/refresh",

    applyjobbyid:"v1/job/apply",

    canceljobbyid:"v1/job/cancel",

    getappliedjobs:"v1/user/applied-jobs",

    getappnotificationcount:"v1/app/notifications/count",

    getappnotificationowner:"v1/app/notifications",

    getappnotificationexpiry:"v1/notification/jobs",

    getappnotificationforowner:"v1/app/notifications"
} //end of 'api' block


// export const blogsmoduleapi = {

//     serviceEndpoint: Api_urls.apiUrl2,

//     getcatapi : "category",
//     activecatapi : "category/activate",

//     getpostapi : "post",
//     activepostapi : "post/activate",

//     getblogsapi : "blog",
//     getsearchblogsapi : "blog/search",

//     getblogcatapi : "blogcategory",
// }